import React from "react";
import { xlsxExport } from "../../../utils/xlsxExport";
import { DownloadIconNew } from "../../../assets/images/svg";

const ExcelExportButton = ({ headers, data, defaultName }) => {
  const handleExport = () => {
    xlsxExport({ headers, data, fileName: defaultName.slice(0, 31) });
  };

  return (
    <button onClick={handleExport} className="button button--secondary table-block__export">
      <DownloadIconNew width={11} height={12} />
      Download As Excel
    </button>
  );
};

export default ExcelExportButton;
